export default __webpack_public_path__ + "static/media/Color_Guard.3d3103e7.jpg";